module.exports = __webpack_public_path__ + "img/increase-happiness.f1ca75a5.svg";